export const filterValues = (value) => Array.isArray(value) ? value : [value];
export const filterMatches = (value, actual) => {
  const values = filterValues(value);
  return !values.length || values.some((item) =>
    !item || item === "__none__" || item === "__all__" || String(item) === String(actual),
  );
};
export const filterParam = (value) => {
  const values = filterValues(value).filter((item) => item && !["__none__", "__all__"].includes(item));
  return Array.isArray(value) ? values : values[0] || "";
};

export const reconcileUnitFilter = (value, grade, units, getGrade, allValue = "__all__") => {
  if (grade === "__none__") return "__none__";
  const selected = filterValues(value).filter((id) => id && !["__none__", "__all__"].includes(id));
  const valid = selected.filter((id) => units.some((unit) =>
    (unit.id || unit.uuid) === id && filterMatches(grade, getGrade(unit)),
  ));
  return valid.length ? Array.isArray(value) ? valid : valid[0] : allValue;
};
